// Types for the developer error-capture overlay (desktop CRM dev tool).
//
// Each captured event becomes a DevErrorEntry. Labels are uppercase so they
// render directly in the badge column of the UI.

export type DevErrorLabel =
  | "NETWORK"
  | "CONSOLE.ERROR"
  | "CONSOLE.WARN"
  | "EXCEPTION"
  | "REJECTION"
  | "OTHER";

/** Severity buckets the UI uses to color the collapsed pill / badges. */
export type DevErrorSeverity = "error" | "warn";

export interface DevErrorEntry {
  /** Unique id for React keys + dedupe. */
  id: string;
  /** Capture label (badge text). */
  label: DevErrorLabel;
  /** Short, one-line title shown in the list row. */
  title: string;
  /** Structured details — pretty-printed in the expanded row and "Copy" output. */
  details: Record<string, unknown>;
  /** Millisecond epoch when the entry was captured. */
  timestamp: number;
}

/** Maps each label to its severity bucket. */
export const LABEL_SEVERITY: Record<DevErrorLabel, DevErrorSeverity> = {
  NETWORK: "error",
  "CONSOLE.ERROR": "error",
  EXCEPTION: "error",
  REJECTION: "error",
  "CONSOLE.WARN": "warn",
  OTHER: "warn",
};
